module.exports = __webpack_public_path__ + "img/wangzhe_pink.0d750518.png";